"use client";

import { SectionTitle } from "./sectionTitle";

export const Judges = () => {
	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="審査" />

			<div className="space-y-6">
				<div className="grid grid-cols-1 gap-4 text-black font-bold font-zenMaru text-xl text-left">
					<p>
						<span>・理想論決力</span>
						<span className="hidden md:inline">・・・・・・</span>
						<span className="md:hidden">
							<br />
						</span>
						<span className="text-gray-600 text-sm md:text-normal">
							理想を適切に把握し、有効なソリューションを提示できているか
						</span>
					</p>
					<p>
						<span>・実現可能性</span>
						<span className="hidden md:inline">・・・・・・</span>
						<span className="md:hidden mb-4 md:mb-0">
							<br />
						</span>
						<span className="text-gray-600 text-sm md:text-normal">
							現実感や実現可能性のレベルを検証できているか
						</span>
					</p>
					<p>
						<span>・市場性</span>
						<span className="hidden md:inline">・・・・・・・・</span>
						<span className="md:hidden mb-2 md:mb-0">
							<br />
						</span>
						<span className="text-gray-600 text-sm md:text-normal">
							市場ニーズを的確に捉え、ビジネスとして成立するか
						</span>
					</p>
					<p>
						<span>・エンジニアリング</span>
						<span className="hidden md:inline">・・・</span>
						<span className="md:hidden mb-2 md:mb-0">
							<br />
						</span>
						<span className="text-gray-600 text-sm md:text-normal">
							理論に対して適切な技術を選定し、イメージできる成果物が開発できているか
						</span>
					</p>
					<p>
						<span>・プレゼン</span>
						<span className="hidden md:inline">・・・・・・・</span>
						<span className="md:hidden">
							<br />
						</span>
						<span className="text-gray-600 text-sm md:text-normal">
							プレゼンの説得力があり、わかりやすく、聴衆を引きつけるものになっているか
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};
